import { Grid, Typography, Box, styled, Avatar } from '../../../../base';

const AVATAR_SIZE = 37;

export const StyledContainer = styled(Grid)(({ theme }) => ({
    paddingBottom: theme.spacing(5),
    width: '100%',
    alignItems: 'flex-start',
    position: 'relative',
    '&:not(:last-child)::before': {
        content: '""',
        position: 'absolute',
        insetInlineStart: AVATAR_SIZE / 2,
        top: AVATAR_SIZE,
        bottom: 0,
        width: 1,
        backgroundColor: theme.palette.divider,
    },
    '&:last-child': {
        paddingBottom: 0,
    },
}));

export const StyledAvatar = styled(Avatar)(({}) => ({
    height: AVATAR_SIZE,
    width: AVATAR_SIZE,
}));

export const StyledTimeText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginInlineStart: theme.spacing(0.5),
}));

export const StyledMessageContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isSender',
})<{ isSender?: boolean }>(({ theme, isSender }) => ({
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: isSender
        ? 'transparent'
        : theme.palette.background.mainBackground,
    width: 'fit-content',
    maxWidth: '100%',
}));
